import { tgxApi } from "../../app/tgxApi";
import { serialize } from "../../helpers/utils/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/utils/RtkQueryUtils";
import { downloadFile, openFileInFrame, openFileInNewTab } from "../../helpers/utils/FileUtils";
import axios from "axios";

export const orderFilesApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        getDeliveryModalDocuments: build.query({
            query: (query) => {
                let paramData = serialize(query);
                return {
                    url: `/ajax/document/search`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: query
                };
            },
            providesTags: ["deliveryModalDocuments"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getOrderDocumentList: build.query({
            query: ({ orderId, orderFileType, includeDeleted }) => {
                let paramData = serialize({
                    orderFileTypes: orderFileType,

                });
                return {
                    url: `/ajax/get-order-document-list/${orderId}?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["orderDocumentList"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateDocumentVisibility: build.mutation({
            query: ({ id }) => {
                return {
                    url: `/ajax/update-doc-visibility/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Document Visibility")
            },
            invalidatesTags: ['orderDocumentList']

        }),
        deleteDocument: build.mutation({
            query: ({ id }) => {
                return {
                    url: `/ajax/delete-file-by-id/${id}/delete`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Document")
            },
            invalidatesTags: ['orderDocumentList']

        }),
        restoreDocument: build.mutation({
            query: ({ id }) => {
                return {
                    url: `/ajax/delete-file-by-id/${id}/restore`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Restore", "Document")
            },
            invalidatesTags: ['orderDocumentList']
        }),
        viewFile: build.query({
            query: ({ fileId, isDownload, isOpenInFrame }) => {
                return {
                    url: `/ajax/view-file/${fileId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                    responseHandler: async (response: any) => {
                        const blob = await response.blob();
                        if (!isOpenInFrame) {
                            const contentDisposition = response.headers.get('Content-Disposition');
                            const filename = contentDisposition
                                ? contentDisposition.split('filename=')[1]
                                : `file_${fileId}.pdf`;

                            isDownload ? downloadFile(blob, filename) : openFileInNewTab(blob)
                        } else {
                            openFileInNewTab(blob);
                        }
                        return { success: true };
                    },
                };

            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        uploadDocument: build.mutation({
            query: ({ orderId, formData }) => ({
                url: `/ajax/upload-file/${orderId}`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: formData,
            }),
            invalidatesTags: ["orderDocumentList", "associationsDocuments",'associationAssignmentLogs','subdivisionDocumentList','collectorDocumentsById','collectorLogsById']
            
        }),

        deliverFile: build.mutation({
            query: ({ orderId, deliveryEmail, files }) => {
                return {
                    url: `/order-files/deliver-file/${orderId}?${serialize({ deliveryEmail: deliveryEmail })}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: files
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Delivered", "files")
            },
            invalidatesTags: ['orderDocumentList', 'orderLogs']

        }),

        generateInvoicePdf: build.mutation({
            query: ({ productId, body }) => {

                return {
                    url: `/order-files/generate/invoice/custom/${productId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: body,
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Generated", "Invoice");
            },
            invalidatesTags: ['orderDocumentList', 'invoiceLines', 'invoiceNotes', 'deliveryModalDocuments'],
        }),
        viewDeliverDocuments: build.query({
            query: ({ fileId, isDownload, isOpenInFrame }) => {
                return {
                    url: `/ajax/view-file/${fileId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                    responseHandler: async (response: any) => {
                        const blob = await response.blob();
                        if (!isOpenInFrame) {
                            const contentDisposition = response.headers.get('Content-Disposition');
                            const filename = contentDisposition
                                ? contentDisposition.split('filename=')[1]
                                : `file_${fileId}.pdf`;

                            isDownload ? downloadFile(blob, filename) : openFileInNewTab(blob)
                        } else {
                            openFileInFrame(blob);
                        }
                        return { success: true };
                    },
                };

            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        uploadMultipleDocument: build.mutation({
            query: ({ orderId, formData }) => ({
                url: `/ajax/upload-multiple-files/${orderId}`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: formData,
            }),
            invalidatesTags: [
                "orderDocumentList", "associationsDocuments",'associationAssignmentLogs','subdivisionDocumentList','collectorDocumentsById','collectorLogsById'
            ]
        }),


    }),
});

export const {
    useGetOrderDocumentListQuery,
    useLazyViewFileQuery,
    useUpdateDocumentVisibilityMutation,
    useDeleteDocumentMutation,
    useRestoreDocumentMutation,
    useGetDeliveryModalDocumentsQuery,
    useDeliverFileMutation,
    useGenerateInvoicePdfMutation,
    useLazyViewDeliverDocumentsQuery,
    useUploadDocumentMutation,
    useUploadMultipleDocumentMutation
} = orderFilesApi;
